// extracted by mini-css-extract-plugin
export default {"side_scroll_area":"VerticalListVirtualizer_side_scroll_area__8x4dF"};